module.exports = __webpack_public_path__ + "img/course_coding.d686b676.jpg";